import { ErrorHandler, Injectable } from '@angular/core';
import { ApplicationInsightsService } from '@app/application-insights/application-insights.service';
import { LoggerService } from '@features/logging/logger.service';
import * as LogRocket from 'logrocket';

@Injectable()
export class GlobalErrorService implements ErrorHandler {
  constructor(
    private loggerService: LoggerService,
    private applicationInsightsService: ApplicationInsightsService,
  ) {}

  handleError(error: Error) {
    LogRocket.captureException(error);
    this.applicationInsightsService.trackError({ exception: error });
    this.loggerService.captureError(error);
  }
}
